import PageHeader from "./components/pageHeader";
import { Layout } from "antd";
import { Outlet, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setCategoryId } from "store/faq/action";
import { WebengageGeneralButtonEvent } from "containers/services/events.data";
import "./index.scss";

const { Content } = Layout;

const PageLayout = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const menu = useSelector((state) => state?.routerReducer);
  const userPma = useSelector((state) => state?.pmaReducer?.userPma);
  const dscode = useSelector((state) => state?.fundReducer?.userFund?.ds_code);
  const prevMenu = useSelector((state) => state?.routerReducer?.prevMenu);

  const goBack = () => {
    const { prevMenu, twoPrevMenu } = menu;
    prevMenu === "/receipt/" ||
    twoPrevMenu === "/fund-orders" ||
    twoPrevMenu === "/pma/receipt/"
      ? navigate("/home", { replace: true })
      : navigate(prevMenu === "/payment/receipt" ? -2 : -1);
  };

  const onClickHeader = (eventName, id) => {
    WebengageGeneralButtonEvent(eventName, prevMenu, "button", {
      "Object Id": id,
    });
  };

  const handleQuestionBtn = () => {
    navigate("/faq/3");
    dispatch(setCategoryId(3));
  };

  return (
    <Layout className="items-center  bg-white">
      <PageHeader
        handleQuestionBtn={handleQuestionBtn}
        page={location.pathname}
        title={menu?.title}
        goBack={goBack}
        prx={userPma?.prx}
        dscode={dscode}
        onClickHeader={onClickHeader}
      />

      <Layout className="w-full max-w-2xl  bg-white">
        <Content
          id="scrollableDiv"
          className="mt-12 sm:mt-20  overflow-auto overflow-x-hidden pb-24"
        >
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
};
export default PageLayout;
